import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Download20 } from '@carbon/icons-react';
import { InlineLoading } from 'carbon-components-react';
import {
  getAttachmentPreviewUrlStart,
  resetAttachmentPreviewUrl,
  getAttachmentDownloadUrlStart,
  resetAttachmentDownloadUrl
} from 'redux/enquiries/actions';
import {
  selectAttachmentPreviewUrl,
  selectLoadingAttachmentPreviewUrl,
  selectAttachmentDownloadUrl,
  selectLoadingAttachmentDownloadUrl
} from 'redux/enquiries';
import { useComponentMount } from 'utilities/hooks.util';

const ImageViewer: React.FC<Props> = ({
  fileId,
  enquiryId,
  imageName,
  isSuperModal
}) => {
  const history = useHistory();
  const queryParams = new URLSearchParams(history?.location.search);
  const shareId = queryParams.get('shareId') || '';

  const dispatch = useDispatch();
  const isLoadingPreviewUrl: any = useSelector(
    selectLoadingAttachmentPreviewUrl
  );
  const previewUrl: any = useSelector(selectAttachmentPreviewUrl);
  const isLoadingDownloadUrl: any = useSelector(
    selectLoadingAttachmentDownloadUrl
  );
  const downloadUrl: any = useSelector(selectAttachmentDownloadUrl);
  const [downloadButtonClicked, setDownloadButtonClicked] = useState<boolean>(
    false
  );

  const [imageUrl, setImageUrl] = useState<string>('');

  useComponentMount(() => {
    dispatch(resetAttachmentPreviewUrl());
    dispatch(resetAttachmentDownloadUrl());
  });

  const downloadImage = () => {
    setDownloadButtonClicked(true);
    dispatch(getAttachmentDownloadUrlStart({ fileId, shareId, enquiryId }));
  };

  useEffect(() => {
    if (!isLoadingDownloadUrl && downloadUrl?.url && downloadButtonClicked) {
      const anchor = document.createElement('a');
      anchor.href = downloadUrl.url;
      anchor.click();
      setTimeout(() => {
        setDownloadButtonClicked(false);
      }, 2000);
    }
  }, [isLoadingDownloadUrl, downloadUrl, downloadButtonClicked]);

  useEffect(() => {
    if (previewUrl && !isLoadingPreviewUrl) {
      setImageUrl(previewUrl.url);
    }
  }, [isLoadingPreviewUrl, previewUrl]);

  useEffect(() => {
    if (fileId && fileId > 0) {
      dispatch(getAttachmentPreviewUrlStart({ fileId, shareId, enquiryId }));
    }
  }, [fileId, shareId, enquiryId, dispatch]);

  return (
    <div className="image-viewer">
      {!isLoadingPreviewUrl && previewUrl ? (
        <>
          <div
            className={`image-viewer-header ${
              isSuperModal ? 'supermodal-header' : ''
            }`}
          >
            <div className="image-viewer-header-file-name">{imageName}</div>
            <div className="image-viewer-header-controls">
              <div
                title={'Download image'}
                className={`image-viewer-header-controls-btn ${
                  downloadButtonClicked
                    ? 'image-viewer-header-controls-btn-disabled'
                    : ''
                }`}
                onClick={() => downloadImage()}
              >
                <Download20 />
              </div>
            </div>
          </div>
          <div className="image-viewer-body">
            <img src={imageUrl} alt="" />
          </div>
        </>
      ) : (
        <div className="image-viewer-loader">
          <InlineLoading description="Preparing response view ..." />
        </div>
      )}
    </div>
  );
};

type Props = {
  fileId?: number;
  enquiryId?: number;
  imageSource: string;
  errorCallBack?: Function;
  imageName?: string;
  isSuperModal?: boolean;
};

export default React.memo(ImageViewer);
